module.exports = __webpack_public_path__ + "media/images/arrow-down-mobile-a56b7e0178600df9260654140c2ad188.png";